module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/controller-84bb8ce6c1793d38cb3f7602f519d860.svg";